// Copyright (c) 2022, Compiler Explorer Authors
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are met:
//
//     * Redistributions of source code must retain the above copyright notice,
//       this list of conditions and the following disclaimer.
//     * Redistributions in binary form must reproduce the above copyright
//       notice, this list of conditions and the following disclaimer in the
//       documentation and/or other materials provided with the distribution.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
// AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
// ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
// LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
// CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
// SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
// INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
// CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
// ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
// POSSIBILITY OF SUCH DAMAGE.

// note that these variables are saved to state, so don't change, only add to it
export enum DiffType {
    ASM = 0,
    CompilerStdOut = 1,
    CompilerStdErr = 2,
    ExecStdOut = 3,
    ExecStdErr = 4,
    GNAT_ExpandedCode = 5,
    GNAT_Tree = 6,
    DeviceView = 7,
    AstOutput = 8,
    IrOutput = 9,
    RustMirOutput = 10,
    RustMacroExpOutput = 11,
    RustHirOutput = 12,
    ClojureMacroExpOutput = 13,
    YulOutput = 14,
    LeanCOutput = 15,
    Source = 16,
}

export type DiffState = {
    lhs: number | string;
    rhs: number | string;
    lhsdifftype: DiffType;
    rhsdifftype: DiffType;
    lhsextraoption?: string;
    rhsextraoption?: string;
};
